import {getHostVariables} from '../../utils';
import {addActionHandler} from '../customEventActionHandler';
import {onAction} from '../onAction';
import {COMPONENT_ACTION_DISPATCHED} from '../../constants';
import {
	RUNTIME_ACTION_HANDLERS,
	TARGETED_ACTION_TYPES,
	ANCESTOR_ROOT_NODE,
	CONFIG,
	ACTION_HANDLERS,
	PRESENTATIONAL
} from '../../symbols';

const shouldApplyActionHandler = (hostVariables, type) =>
	!hostVariables[PRESENTATIONAL] &&
	!hostVariables[RUNTIME_ACTION_HANDLERS].includes(type) &&
	hostVariables[TARGETED_ACTION_TYPES].includes(COMPONENT_ACTION_DISPATCHED);

const createActionHandler = (host, hostVariables, type) => {
	hostVariables[RUNTIME_ACTION_HANDLERS].push(type);

	if (
		hostVariables[CONFIG].interceptors[type] &&
		hostVariables[CONFIG].interceptors[type].has('host')
	) {
		const interceptors = [
			...hostVariables[CONFIG].interceptors[type].get('host'),
			...hostVariables[CONFIG].interceptors[COMPONENT_ACTION_DISPATCHED].get('host')
		];
		hostVariables[CONFIG].interceptors[type].set('host', interceptors);
		return;
	}

	hostVariables[CONFIG].interceptors[type] =
		hostVariables[CONFIG].interceptors[COMPONENT_ACTION_DISPATCHED]; // eslint-disable-line no-param-reassign
	const removeActionHandler = addActionHandler(host, 'host', host, type, false, false, onAction);
	hostVariables[ACTION_HANDLERS].push(removeActionHandler);
	hostVariables[TARGETED_ACTION_TYPES] = [...hostVariables[TARGETED_ACTION_TYPES], type]; // eslint-disable-line no-param-reassign
};

export function applyRuntimeActionHandlers(host, type) {
	let parent = host;
	let parentVariables = getHostVariables(parent);

	while (parent) {
		if (shouldApplyActionHandler(parentVariables, type))
			createActionHandler(parent, parentVariables, type);

		parent = parentVariables[ANCESTOR_ROOT_NODE];
		parentVariables = getHostVariables(parent);
	}
}
